var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.32812 0.43125H1.22812V0.53125V1.78726V1.82368L1.25155 1.85158L3.54337 4.57994L3.57334 4.61562H3.61994H5.00753H5.22213L5.0841 4.45131L2.76778 1.69375H15.0491L10.0157 7.98557L9.99375 8.01296V8.04804V13.2854L8.06875 15.2104V12.2188V12.1187H7.96875H6.90625H6.80625V12.2188V16.4688V16.5688H6.90625H8.45441H8.49583L8.52512 16.5395L11.227 13.8376L11.2563 13.8083V13.7669V8.45579L16.5468 1.84256L16.5688 1.81516V1.78009V0.53125V0.43125H16.4688H1.32812Z",
    fill: "#8F96A5",
    stroke: "#8F96A5",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52573 8.24127L7.53322 6.23374L6.78193 5.48242L4.77441 7.48995L2.76688 5.48242L2.01562 6.23374L4.02312 8.24127L2.01562 10.2488L2.76688 11.0001L4.77441 8.99256L6.78193 11.0001L7.53322 10.2488L5.52573 8.24127V8.24127Z",
    fill: "#8F96A5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.7d2518c96d720ac8756d63f3a81d408a.svg";
export { ForwardRef as ReactComponent };